import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from '../IntegrationDefinition';

import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';

const IntercomDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.Intercom,
  hasCustomUI: false,
  friendlyName: 'Intercom',
  description:
    'Defines the properties required for an Intercom integration. Intercom provides a chat or messenger experience for users; conversations and help articles are stored on Intercom. User identity and company (channel) are passed when initializing the widget.',
  category: IntegrationCategoryEnum.Communication,
  platforms: [PlatformEnum.Web, PlatformEnum.Mobile],
  type: IntegrationTypeEnum.SDK,
  settings: {},
  properties: {
    subHeading: {
      type: String.name,
      validators: [],
      friendlyName:
        'Enter your Intercom credentials to enable live chat support for your channel members.',
    },
    appId: {
      type: String.name,
      friendlyName: 'App ID',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
      fixedLabel: true,
    },
    androidApiKey: {
        type: String.name,
        friendlyName: 'Android API Key',
        validators: [
          {
            name: 'Required',
            value: true,
          },
        ],
        fixedLabel: true,
      },
      iosApiKey: {
        type: String.name,
        friendlyName: 'iOS API Key',
        validators: [
          {
            name: 'Required',
            value: true,
          },
        ],
        fixedLabel: true,
      },
  },
};

export const definition = IntercomDefinition;